import React from 'react';
import { useSelector } from 'react-redux';
import { Drawer } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import styles from './user-details.module.scss';
import { getLang } from 'shared/store/selectors/lang.selector';
import _, { uniqueId } from 'lodash';
import { SectionTitle } from '../design-system/titles';
import { UserDetailsForm } from './user-details-form';
import { formatFullName } from 'shared/utils';
import { colorPalette, USER_PERMISSIONS } from 'shared/constants';
import { IconButton } from '../design-system';

const UserDetailsComponent = React.memo(function UserDetailsComponent({
  user: userData,
  close,
  open,
  ...props
}) {
  const lang = useSelector(getLang('USERS_MANAGEMENT'));
  const closeLabel = useSelector(getLang('ACTION_BUTTON_TOOLTIPS')).CLOSE;
  const isNewUser = _.isEmpty(userData);
  const isBulkUpdate = _.isArray(userData) && userData.length > 1;
  const user = _.isArray(userData) && !isBulkUpdate ? userData[0] : userData;
  const fullName = formatFullName(user);

  const allowToBulkUpdatePermissions =
    isBulkUpdate && userData.every(u => u.permissions === USER_PERMISSIONS.VIEWER);

  const title = isBulkUpdate
    ? lang.EDIT_USER.replace('{number}', user.length ?? '')
    : !isNewUser
      ? `${fullName}`
      : lang.ADD_NEW_USER;

  return (
    <Drawer
      open={open}
      onClose={close}
      size={330}
      placement="right"
      destroyOnHidden
      className="new-design-system"
      closable={false}
      title={
        <div className={styles.header}>
          <SectionTitle title={title} wrapperClassName={styles.title} />
          <IconButton
            tooltipProps={{
              placement: 'left',
            }}
            onClick={close}
            label={closeLabel}
            className={styles.close}>
            <FontAwesomeIcon icon={faXmark} color={colorPalette.primaryMain9} size="xl" />
          </IconButton>
        </div>
      }>
      <UserDetailsForm
        key={`details-form-${user?.id ?? uniqueId()}`}
        user={user}
        onFinish={close}
        isBulkUpdate={isBulkUpdate}
        allowToBulkUpdatePermissions={allowToBulkUpdatePermissions}
        {...props}
      />
    </Drawer>
  );
});

export { UserDetailsComponent };
